import NewPunkt from './NewPunkt';
export default NewPunkt;